export const scrollTo = (el, delay = 0) => {
    const headerHeight = document.getElementsByTagName('header')[0].offsetHeight;
    const TitleHeight = document.getElementsByClassName('ornament')[0].offsetHeight;

    setTimeout(() => {
        window.scrollTo({
            top: el.offsetTop + headerHeight + TitleHeight - 40,
            behavior: 'smooth',
        });
    }, delay);
};
